import { Mail, Phone, MapPin } from "lucide-react";

export const Contact = () => {
  return (
    <section id="kontakt" className="px-6 lg:px-8 py-24 lg:py-32 bg-ink text-paper">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-widest uppercase text-sun mb-4 block">Kontakta oss</span>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-balance mb-6">
            Låt oss prata om er förening.
          </h2>
          <p className="text-lg text-paper/90 leading-relaxed text-pretty mb-10 max-w-md">
            Boka ett kostnadsfritt rådgivningssamtal via telefon eller videomöte så går vi igenom era behov tillsammans.
          </p>

          <ul className="space-y-5">
            <li className="flex items-center gap-4">
              <span className="size-10 rounded-full bg-paper/10 flex items-center justify-center">
                <Mail className="size-4" />
              </span>
              <a href="mailto:info@adminlaget.se" className="hover:text-sun transition-colors">info@adminlaget.se</a>
            </li>
            <li className="flex items-center gap-4">
              <span className="size-10 rounded-full bg-paper/10 flex items-center justify-center">
                <Phone className="size-4" />
              </span>
              <a href="tel:+46727033233" className="hover:text-sun transition-colors">072-703 32 33</a>
            </li>
            <li className="flex items-center gap-4">
              <span className="size-10 rounded-full bg-paper/10 flex items-center justify-center">
                <MapPin className="size-4" />
              </span>
              <span>Hela Sverige, med huvudkontor i Strängnäs</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};